import { useEffect } from "react";
import "./developmentTutorial.css";
import { Helmet } from "react-helmet";


export default function DevelopmentTutorial() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Development Tutorials - Learn & Grow</title>
        <meta
          name="description"
          content="Access SHOP.CO development tutorials to learn tips, guides, and resources that help you make the most of our platform and features."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/resources/development-tutorial/"
        />
      </Helmet>
      <div className="tutorial-container">
        <header className="tutorial-header">
          <h1>Development Tutorials</h1>
          <p>Step-by-step guides and resources to help you become a better developer.</p>
        </header>

        <section className="tutorial-section">
          <div className="tutorial-article">
            <h2>🚀 Getting Started with Web Development</h2>
            <p>
              This guide will walk you through the basics of HTML, CSS, and JavaScript. You'll learn how to structure a webpage, style it, and add interactivity.
            </p>
            <ul>
              <li>Introduction to HTML5</li>
              <li>Responsive design with CSS Flexbox/Grid</li>
              <li>DOM manipulation using JavaScript</li>
            </ul>
          </div>

          <div className="tutorial-article">
            <h2>⚛️ Learn React from Scratch</h2>
            <p>
              React is one of the most popular libraries for building UI. This section covers JSX, components, hooks, and more.
            </p>
            <ul>
              <li>JSX syntax and structure</li>
              <li>Functional vs class components</li>
              <li>Using `useState` and `useEffect`</li>
            </ul>
          </div>

          <div className="tutorial-article">
            <h2>📦 Redux for State Management</h2>
            <p>
              Understand how to manage global state in large applications with Redux Toolkit.
            </p>
            <ul>
              <li>Slices and Reducers</li>
              <li>Actions and Middleware</li>
              <li>Integrating Redux with React</li>
            </ul>
          </div>

          <div className="tutorial-article">
            <h2>💻 Fullstack Project Tutorial</h2>
            <p>
              Build a fullstack MERN application including authentication, APIs, and a dashboard interface.
            </p>
            <ul>
              <li>MongoDB and Express setup</li>
              <li>React frontend + routing</li>
              <li>JWT authentication</li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
}
